import { OptionItemProps } from './option';

export const TONE_OPTIONS: OptionItemProps[] = [
    {
        label: 'Friendly',
        value: 'friendly',
        icon: {
            kind: 'emoji',
            text: '😊',
        },
    },
    {
        label: 'Professional',
        value: 'professional',
        icon: {
            kind: 'emoji',
            text: '👔',
        },
    },
    {
        label: 'Casual',
        value: 'casual',
        icon: {
            kind: 'emoji',
            text: '👋',
        },
    },
    {
        label: 'Confident',
        value: 'confident',
        icon: {
            kind: 'emoji',
            text: '💪',
        },
    },
    {
        label: 'Optimistic',
        value: 'optimistic',
        icon: {
            kind: 'emoji',
            text: '🤩',
        },
    },
];
